import { render, staticRenderFns } from "./Formform.vue?vue&type=template&id=a4d0f522&"
import script from "./Formform.vue?vue&type=script&lang=js&"
export * from "./Formform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports